import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useContext, useState } from "react";
import SelectCustomer from "./SelectCustomer";
import SelectProject from "./SelectProject";
import { useTheme } from "@emotion/react";
import moment from "moment/moment";
import { AuthContext } from "../../../../context/AuthContext";
import * as Sentry from "@sentry/react";
import SelectCompanyEmployee from "./SelectCompanyEmployee";
import SelectSalesRep from "./SelectSalesRep";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const TopSection = ({ quote, onUpdateQuote }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [showConfirmedCutListInfo, setShowConfirmedCutListInfo] =
    useState(false);
  const [showUnConfirmedCutListInfo, setShowUnConfirmedCutListInfo] =
    useState(false);

  // Tax Form
  const { authToken, ezorder } = useContext(AuthContext);
  const [taxFormModalOpen, setTaxFormModalOpen] = useState(false);
  const [taxFormModalFile, setTaxFormModalFile] = useState(null);
  const [newTaxFormName, setNewTaxFormName] = useState("");
  const [newTaxFormExpirationDate, setNewTaxFormExpirationDate] = useState(
    moment().format("MM/DD/YYYY")
  );
  const [isLoading, setIsLoading] = useState(false);

  const onUpdateCustomer = (company) => {
    // Set Company Value and Set Project and vendorProjectName to Null
    let update = {
      company: company,
      project: null, // Reset Project
      vendorProjectName: null, // Reset Vendor Project Name
      primaryContact: null, // Reset Primary Contact Selected
      estimateRequestedBy: null, // Reset Primary Contact Selected
      items: [], // reset all items
      taxExemptForm: company.yearlyTaxForm, // Set Company's Default Tax Form as Order Tax Form
      salesRep: company.assignedSalesRep,
    };
    console.log("COMPANY UPDATE", update);
    onUpdateQuote(update);
  };

  const onUpdateProject = (project) => {
    // Set Company Value and Set Project to Null
    let update = { project: project };
    onUpdateQuote(update);
  };

  const onUpdatePrimaryContact = (primaryContact) => {
    // Set Company Value and Set Project to Null
    let update = {
      primaryContact: primaryContact,
      estimateRequestedBy: primaryContact,
    };
    onUpdateQuote(update);
  };

  const onUpdateSalesRep = (salesRep) => {
    // Set Company Value and Set Project to Null
    let update = {
      salesRep,
    };
    onUpdateQuote(update);
  };

  const onUpdateItemizedEstimate = (isItemizedEstimate) => {
    // Set Company Value and Set Project to Null
    let update = { isItemizedEstimate: isItemizedEstimate };
    onUpdateQuote(update);
  };

  if (quote)
    return (
      <Box>
        <Typography variant="h6">Project Details</Typography>
        <Box sx={{ marginTop: "8px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <SelectCustomer
                required
                value={quote.company}
                onUpdate={(company) => {
                  onUpdateCustomer(company);
                }}
                label="Customer"
                enableAdd={true}
              />
            </Box>
            <Box
              sx={{
                flex: 1,
                marginLeft: isSmallScreen ? 0 : "8px",
                marginTop: isSmallScreen ? "8px" : 0,
              }}
            >
              {quote.company && (
                <SelectProject
                  required
                  disabled={!quote.company}
                  companyId={quote.company ? quote.company.id : null}
                  value={quote.project}
                  onUpdate={(project) => {
                    const { id, isVendorCustomer, name } = project;
                    onUpdateProject({ id, isVendorCustomer, name });
                  }}
                  label="Project"
                  enableAdd={true}
                />
              )}
            </Box>
            <Box
              sx={{
                flex: 1,
                marginLeft: isSmallScreen ? 0 : "8px",
                marginTop: isSmallScreen ? "8px" : 0,
              }}
            >
              {quote.company && (
                <SelectCompanyEmployee
                  required
                  disabled={!quote.company}
                  companyId={quote.company ? quote.company.id : null}
                  value={quote.estimateRequestedBy}
                  onUpdate={(user) => {
                    onUpdatePrimaryContact(user);
                  }}
                  label="Primary Contact"
                  enableAdd={true}
                />
              )}
            </Box>
          </Box>
          {quote.company && (
            <Box
              sx={{
                marginTop: isSmallScreen ? 0 : "8px",
                display: "flex",
                flexDirection: isSmallScreen ? "column" : "row",
              }}
            >
              {quote.company && quote.company.isVendorOrSupplier && (
                <TextField
                  sx={{
                    flex: 1,
                    marginTop: isSmallScreen ? "8px" : 0,
                    marginRight: isSmallScreen ? 0 : "8px",
                  }}
                  variant="outlined"
                  label="Vendor/Supplier Project Name"
                  id="project-name"
                  name="Project Name"
                  size="small"
                  fullWidth
                  value={quote.vendorProjectName}
                  onChange={(e) => {
                    let update = { vendorProjectName: e.target.value };
                    onUpdateQuote(update);
                  }}
                />
              )}
              <TextField
                sx={{
                  flex: 1,

                  marginTop: isSmallScreen ? "8px" : 0,
                }}
                variant="outlined"
                label="Sub-Project Name (ie Bldg #, etc)"
                id="sub-project"
                name="Sub-Project Name (ie Bldg #, etc)"
                size="small"
                fullWidth
                value={quote.subProject}
                onChange={(e) => {
                  let update = { subProject: e.target.value };
                  onUpdateQuote(update);
                }}
              />
              <TextField
                sx={{
                  flex: 1,
                  marginLeft: isSmallScreen ? 0 : "8px",
                  marginTop: isSmallScreen ? "8px" : 0,
                }}
                variant="outlined"
                label="P.O.#"
                id="po-number"
                name="PO Number"
                size="small"
                fullWidth
                value={quote.poNumber}
                onChange={(e) => {
                  let update = { poNumber: e.target.value };
                  onUpdateQuote(update);
                }}
              />

              <Box
                sx={{
                  flex: 1,
                  marginLeft: isSmallScreen ? 0 : "8px",
                  marginTop: isSmallScreen ? "8px" : 0,
                }}
              >
                <SelectSalesRep
                  disabled={!quote.company}
                  companyId={quote.company ? quote.company.id : null}
                  value={quote.salesRep}
                  onUpdate={(user) => {
                    // if (user) updateOrderSalesRep(user);
                    onUpdateSalesRep(user);
                  }}
                  label="Sales Rep"
                />
              </Box>
            </Box>
          )}

          <Box
            sx={{
              marginTop: "16px",
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
            }}
          >
            <Box sx={{ width: "200px", marginRight: "16px" }}>
              <TextField
                sx={{}}
                disabled={
                  quote &&
                  quote.orderStatus &&
                  quote.orderStatus.name != "QUOTE_REQUESTED"
                }
                select
                variant="outlined"
                label="Is this a final cut-list?"
                size="small"
                fullWidth
                value={quote.quoteType}
                onChange={(e) => {
                  if (e.target.value == "Free Text") {
                    // IF free text, remove products, skid charge, etc. Reset out the door cost
                    onUpdateQuote({
                      quoteType: e.target.value,
                      items: [], // empty out the items
                      isItemizedEstimate: false,
                      skidCharge: 0,
                      outTheDoorCost: 0,
                    });
                  } else {
                    onUpdateQuote({
                      quoteType: e.target.value,
                    });
                  }
                }}
              >
                <MenuItem value={"Confirmed Cut-List"}>
                  Confirmed Cut-List
                </MenuItem>
                <MenuItem value={"Preliminary Cut-List"}>
                  Preliminary Cut-List
                </MenuItem>
                <MenuItem value={"Free Text"}>Free Text</MenuItem>
              </TextField>

              {quote.quoteType !== "Free Text" && (
                <FormControl sx={{ width: "200px", marginTop: "16px" }}>
                  <FormLabel>Show Price Per Piece</FormLabel>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={quote.isItemizedEstimate}
                          onChange={(e) => {
                            onUpdateItemizedEstimate(e.target.checked);
                          }}
                          name="gilad"
                        />
                      }
                      label="Price Per Piece"
                    />
                  </FormGroup>
                </FormControl>
              )}
            </Box>
            {quote.quoteType !== "Free Text" && (
              <Box sx={{ flex: 1 }}>
                <TextField
                  multiline
                  rows={3}
                  variant="outlined"
                  label="Order Notes"
                  id="quoteNotes"
                  name="quoteNotes"
                  fullWidth
                  value={quote.quoteNotes}
                  onChange={(e) => {
                    onUpdateQuote({ quoteNotes: e.target.value });
                  }}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    );
};

function CheckboxRadio(props) {
  return (
    <Radio
      disableRipple
      checkedIcon={<CheckBox color="primary" />}
      icon={<CheckBoxOutlineBlank />}
      {...props}
    />
  );
}

export default TopSection;
